


















import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import SwLogin from './components/sw-login.vue';
import { LoginModel } from './interfaces/sw-login-interfaces';
@Component({
  components: {
    SwLogin,
  },
})
export default class MswSpogLogin extends SwExtendedVue {

  loginModel: LoginModel = {
    loginAttempted: false,
    email: '',
    password: '',
  };
  doLogin() {
    this.$router.push({ path: 'm/feature/spog-homepage' });
  }
  created() {
    console.warn(this.$route.query);
  }
}
